// GENERATED by web/tools/extract-tile-colours.py - do not edit by hand.
//
// The letter -> colour mapping read out of the C game's tile atlas
// (data/tiles/tiles.png). The mockup's colours are illustrative; these are the
// ones the game actually shipped with.

export const TILE_COLOURS: Readonly<Record<string, number>> = Object.freeze({
  a: 0xf3bd00, // rgb(243, 189, 0)
  b: 0x0050ae, // rgb(0, 80, 174)
  c: 0x0050ae, // rgb(0, 80, 174)
  d: 0x4d9000, // rgb(77, 144, 0)
  e: 0xe3b400, // rgb(227, 180, 0)
  f: 0x680a68, // rgb(104, 10, 104)
  g: 0x4f9400, // rgb(79, 148, 0)
  h: 0x660966, // rgb(102, 9, 102)
  i: 0x0053bb, // rgb(0, 83, 187)
  j: 0xb20070, // rgb(178, 0, 112)
  k: 0xca5400, // rgb(202, 84, 0)
  l: 0xda5500, // rgb(218, 85, 0)
  m: 0x003e7c, // rgb(0, 62, 124)
  n: 0x4d9100, // rgb(77, 145, 0)
  o: 0xdcb300, // rgb(220, 179, 0)
  p: 0x0051b7, // rgb(0, 81, 183)
  q: 0xba0000, // rgb(186, 0, 0)
  r: 0xdab300, // rgb(218, 179, 0)
  s: 0xe0b600, // rgb(224, 182, 0)
  t: 0xffc000, // rgb(255, 192, 0)
  u: 0x4f9400, // rgb(79, 148, 0)
  v: 0x680a68, // rgb(104, 10, 104)
  w: 0x5d095d, // rgb(93, 9, 93)
  x: 0xa20069, // rgb(162, 0, 105)
  y: 0x680968, // rgb(104, 9, 104)
  z: 0xc40000, // rgb(196, 0, 0)
});

export const TILE_COLOUR_FALLBACK = 0x2f6fd0;

export function tileColour(letter: string): number {
  return TILE_COLOURS[letter.toLowerCase()] ?? TILE_COLOUR_FALLBACK;
}
